// extracted by mini-css-extract-plugin
export default {"PricingFaq":"PricingFaq_PricingFaq__-51s+","faq_grid":"PricingFaq_faq_grid__TLd1A","left_side":"PricingFaq_left_side__TPRiI","mainheading":"PricingFaq_mainheading__NBj9Z"};